import { render } from "./App.vue?vue&type=template&id=d2c41684&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d2c41684&lang=css"
import "./App.vue?vue&type=style&index=1&id=d2c41684&scoped=true&lang=scss"

import exportComponent from "F:\\fontre\\chery_project\\chery-omoda\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2c41684"]])

export default __exports__